const key3 = 'wNLf2plwvtlcCxam'

export default key3
